var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowBlazingUpCorner = function SvgArrowBlazingUpCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.966 11.37-.084-6.067a.691.691 0 0 1 .71-.708.769.769 0 0 1 .747.735l.212 6.078a.748.748 0 0 1-.764.782h-.009a.84.84 0 0 1-.812-.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.659 5.997 5.953-.01a.69.69 0 0 0 .695-.69.71.71 0 0 0-.683-.707l-6.002-.17a.753.753 0 0 0-.782.777.826.826 0 0 0 .819.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.705 12.377 5.529-5.53c.305-.306.293-.813-.027-1.133-.32-.32-.826-.332-1.132-.026l-5.529 5.53c-.305.306-.293.813.027 1.133.32.32.826.332 1.132.026z"
  })));
};

export default SvgArrowBlazingUpCorner;